import { render, staticRenderFns } from "./UberEatsArticleOptionsForm.vue?vue&type=template&id=c8ea9762"
import script from "./UberEatsArticleOptionsForm.vue?vue&type=script&lang=ts"
export * from "./UberEatsArticleOptionsForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports